import axios from 'axios';

// Create axios instance with base URL that works in both development and production
const api = axios.create({
  // Use relative URL in production to avoid hardcoded hostnames
  baseURL: process.env.NODE_ENV === 'production' ? '/api' : (process.env.REACT_APP_API_URL || 'http://localhost:5000/api'),
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add request interceptor for authentication
api.interceptors.request.use(
  (config) => {
    // Only add auth header for admin routes or explicitly authenticated routes
    if (config.url.includes('/admin') || 
        config.url.includes('/auth') || 
        config.authenticated) {
      const token = localStorage.getItem('auth_token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor for handling errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 Unauthorized errors
    if (error.response && error.response.status === 401 && 
       (error.config.url.includes('/admin') || error.config.url.includes('/auth'))) {
      // Clear token and redirect to login
      localStorage.removeItem('auth_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;